import React from 'react';
import { Button } from 'react-bootstrap';
import './LoaderButton.css';

const loaderButton = ({
  isLoading,
  text,
  loadingText,
  className = '',
  disabled = false,
  ...props
}) => (
  <Button
    className={`LoaderButton ${className}`}
    disabled={disabled || isLoading}
    {...props}
  >
    {isLoading && <i className="fas fa-sync-alt fa-spin" />}
    {!isLoading ? text : loadingText}
  </Button>
);

export default loaderButton;